'use client';
import React, { useState, useEffect } from 'react';
import Image from 'next/image';

const footerLinks = [
  {
    heading: 'Explore',
    links: [
      { label: 'All Articles', href: '#articles' },
      { label: 'Theories', href: '#theories' },
      { label: 'Stories', href: '#' },
      { label: 'Observations', href: '#' },
      { label: 'Videos', href: '#videos' },
      { label: 'Deep Dives', href: '#' },
    ],
  },
  {
    heading: 'Topics',
    links: [
      { label: 'Cosmology', href: '#topics' },
      { label: 'Biology', href: '#topics' },
      { label: 'Physics', href: '#topics' },
      { label: 'Philosophy', href: '#topics' },
      { label: 'Chemistry', href: '#topics' },
      { label: 'Civilization', href: '#topics' },
    ],
  },
  {
    heading: 'More Topics',
    links: [
      { label: 'Mathematics', href: '#topics' },
      { label: 'Evolution', href: '#topics' },
      { label: 'Technology', href: '#topics' },
      { label: 'Neuroscience', href: '#topics' },
      { label: 'Astronomy', href: '#topics' },
      { label: 'Geology', href: '#topics' },
    ],
  },
  {
    heading: 'About',
    links: [
      { label: 'About Us', href: '#' },
      { label: 'Our Mission', href: '#' },
      { label: 'Write for Us', href: '#' },
      { label: 'Contact', href: '#' },
      { label: 'Privacy Policy', href: '#' },
      { label: 'Terms of Use', href: '#' },
    ],
  },
  {
    heading: 'Subscribe',
    links: [
      { label: 'Free Newsletter', href: '#subscribe' },
      { label: 'RSS Feed', href: '#' },
    ],
  },
];

const socialLinks = [
  {
    label: 'YouTube',
    href: '#',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
  {
    label: 'Twitter / X',
    href: '#',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    label: 'Instagram',
    href: '#',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    href: '#',
    icon: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
];

export default function Footer() {
  const [year, setYear] = useState(2025);

  useEffect(() => {
    setYear(new Date()?.getFullYear());
  }, []);

  return (
    <footer className="bg-[#040710]">
      {/* CTA Banner */}
      <div className="bg-[#0d1120] border-t border-b border-[#1e2a3a] py-12">
        <div className="max-w-[1280px] mx-auto px-6 md:px-16">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h2
                className="text-white font-bold mb-1"
                style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: 'clamp(22px, 3vw, 32px)',
                  lineHeight: '1.2',
                }}
              >
                Want to Go{' '}
                <span style={{ color: '#e01a2e' }}>Deeper?</span>
              </h2>
              <p
                className="text-[#a0aec0] text-[15px]"
                style={{ fontFamily: 'Roboto, sans-serif' }}
              >
                Explore thousands of articles about the inception of everything.{' '}
                <span className="text-white font-medium">Join 12,000+ readers</span> worldwide.
              </p>
            </div>
            <a
              href="#subscribe"
              className="flex-shrink-0 inline-flex items-center gap-2 bg-[#e01a2e] hover:bg-[#c0152a] text-white font-semibold text-[14px] px-7 py-3 rounded-[3px] transition-all duration-200"
              style={{ fontFamily: 'Roboto, sans-serif' }}
            >
              Subscribe Free
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      {/* Main Footer */}
      <div className="max-w-[1280px] mx-auto px-6 md:px-16 py-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mb-10">
          {footerLinks?.map((col) => (
            <div key={col?.heading}>
              <h3
                className="text-white font-semibold text-[13px] mb-4 uppercase tracking-wider"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                {col?.heading}
              </h3>
              <ul className="space-y-2">
                {col?.links?.map((link) => (
                  <li key={link?.label}>
                    <a
                      href={link?.href}
                      className="text-[#585757] text-[13px] hover:text-[#e01a2e] transition-colors duration-200"
                      style={{ fontFamily: 'Roboto, sans-serif' }}
                    >
                      {link?.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Contact Column */}
          <div>
            <h3
              className="text-white font-semibold text-[13px] mb-4 uppercase tracking-wider"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Contact Us
            </h3>
            <div className="space-y-3">
              <div>
                <p className="text-[#585757] text-[12px] mb-0.5" style={{ fontFamily: 'Roboto, sans-serif' }}>
                  Email:
                </p>
                <a
                  href="mailto:hello@theinceptions.com"
                  className="text-white text-[13px] font-semibold hover:text-[#e01a2e] transition-colors duration-200"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  hello@theinceptions.com
                </a>
              </div>
              <div className="flex gap-3 pt-2">
                {socialLinks?.map((s) => (
                  <a
                    key={s?.label}
                    href={s?.href}
                    aria-label={s?.label}
                    className="text-[#585757] hover:text-[#e01a2e] transition-colors duration-200"
                  >
                    {s?.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#1e2a3a] pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <Image
              src="/assets/images/Untitled_design__2_-1781814632158.png"
              alt="The Inceptions Logo — dark starburst design with white text"
              width={28}
              height={28}
              className="rounded-sm object-cover opacity-70"
            />
            <span
              className="text-[#585757] text-[12px]"
              style={{ fontFamily: 'Roboto, sans-serif' }}
            >
              &copy; {year} The Inceptions.com
            </span>
          </div>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-[#585757] text-[12px] hover:text-[#e01a2e] transition-colors duration-200"
              style={{ fontFamily: 'Roboto, sans-serif' }}
            >
              Terms of Use
            </a>
            <span className="text-[#2d3748]">|</span>
            <a
              href="#"
              className="text-[#585757] text-[12px] hover:text-[#e01a2e] transition-colors duration-200"
              style={{ fontFamily: 'Roboto, sans-serif' }}
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
